import { Button, Form, Icon, Input, Select } from "antd";
import React, { Component } from "react";
import "../SearchForm/SearchForm.css";
import FormItem from "antd/lib/form/FormItem";
import { SelectAntdOptions } from "../../config/messageStatus";

const { Option } = Select;

class Search extends Component {
  componentDidMount() {
    if (typeof this.props.onRef === "function") this.props.onRef(this);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.fn(this.props.form);
  };

  handleReset = () => {
    this.props.form.resetFields();
    this.props.fnReset();
  };

  clearTxtSearch = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { countryList, gatewayList } = this.props;

    return (
      <Form className="search-frm" layout="inline" onSubmit={this.handleSubmit}>
        {this.props.table === "sms" && (
          <Form.Item>
            {getFieldDecorator("sl_type", {
              initialValue: "campaign",
              rules: [{ required: false }],
            })(
              <Select
                showSearch
                placeholder="SMS Type"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: "250px" }}
              >
                <Option key="sl_type-1" value="campaign">
                  Campaign
                </Option>
                <Option key="sl_type-2" value="api">
                  API
                </Option>
              </Select>
            )}
          </Form.Item>
        )}

        <Form.Item>
          {getFieldDecorator("gateway_id", {
            rules: [{ required: false }],
          })(
            <Select
              showSearch
              allowClear
              placeholder="Gateway"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: "250px" }}
            >
              {(gatewayList || []).map((item, i) => (
                <Option key={i} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("country_abbr", {
            rules: [{ required: false }],
          })(
            <Select
              showSearch
              allowClear
              placeholder="Country"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              style={{ width: "200px" }}
            >
              {(countryList || []).map((item, i) => (
                <Option key={i} value={item.region_code}>
                  {item.name}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <FormItem>
          {getFieldDecorator("status", {
            rules: [{ required: false, message: "กรุณากรอกข้อความ" }],
          })(
            <Select
              placeholder="Status"
              allowClear
              showSearch
              style={{ width: "9rem" }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {SelectAntdOptions()}
            </Select>
          )}
        </FormItem>
        <Form.Item>
          {getFieldDecorator("searchTxt", {
            rules: [{ required: false, message: "กรุณากรอกข้อความ" }],
          })(
            <Input
              prefix={
                <Icon type="search" style={{ color: "rgba(0,0,0,.25)" }} />
              }
              placeholder={"Email,MessageID"}
              style={{ width: "200px" }}
              allowClear
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button.Group>
            <Button htmlType="submit" icon="search" />
            <Button icon="redo" onClick={this.handleReset} />
          </Button.Group>
        </Form.Item>
      </Form>
    );
  }
}

const SearchForm = Form.create({ name: "search-frm" })(Search);

export default SearchForm;



// WEBPACK FOOTER //
// ./src/containers/SmsLogs/search-form.js